import { render, staticRenderFns } from "./ViewBookASeatsDialog.vue?vue&type=template&id=260f5282&scoped=true"
import script from "./ViewBookASeatsDialog.vue?vue&type=script&lang=js"
export * from "./ViewBookASeatsDialog.vue?vue&type=script&lang=js"
import style0 from "./ViewBookASeatsDialog.vue?vue&type=style&index=0&id=260f5282&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260f5282",
  null
  
)

export default component.exports